// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import '../blog.css';
// import Header from "../headerFooter/header";
// import HomeFooter from "../homepage/homefooter";
// const BlogList = () => {
//   const [blogs, setBlogs] = useState([]);
//   // --- CHANGE 1: State to manage the number of visible blogs ---
//   const [visibleBlogs, setVisibleBlogs] = useState(6); // Show 6 blogs initially

//   useEffect(() => {
//     // fetch("https://satvicpath.com/wp-json/wp/v2/posts?_embed&per_page=100")
//     fetch("https://satvicpath.com/wordpress/wp-json/wp/v2/posts?_embed")
//       .then((res) => {
//         if (!res.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return res.json();
//       })
//       .then((data) => {
//         const formatted = data.map((post) => ({
//           slug: post.slug,
//           title: post.title.rendered,
//           date: new Date(post.date).toLocaleDateString(),
//           author: post._embedded.author[0].name,
//           excerpt: post.excerpt.rendered.replace(/<[^>]+>/g, ""),
//           image: post._embedded["wp:featuredmedia"]
//             ? post._embedded["wp:featuredmedia"][0].source_url
//             : "https://via.placeholder.com/400x200",
//         }));
//         setBlogs(formatted);
//       })
//       .catch((error) => {
//         console.error("There was a problem with the fetch operation:", error);
//       });
//   }, []);

//   // --- CHANGE 2: Function to load more blogs ---
//   const handleShowMore = () => {
//     setVisibleBlogs((prevVisibleBlogs) => prevVisibleBlogs + 6); // Increase by 6
//   };

//   return (
//     <>
//       <Header />
//       <section className="blog-section" id="blogs">
//         <h1 className="blog-heading">Blogs</h1>
//         <p className="sec-subtitle">“Insights for your satvic journey"</p>

//       <div className="blog-grid">
//         {/* --- CHANGE 3: Slice the array to show only a limited number of blogs --- */}
//         {blogs.slice(0, visibleBlogs).map((blog) => (
//           <div className="blog-card" key={blog.slug}>
//              <Link to={`/post/${blog.slug}`}>
//               <img src={blog.image} alt={blog.title} className="blog-image" />
//             </Link>
//             <div className="blog-meta">
//               <p className="blog-author"> {blog.date}</p>
//               {/* <p className="blog-author">{blog.author}, {blog.date}</p> */}
//               <Link to={`/post/${blog.slug}`}>
//                 <h2 className="blog-title">{blog.title}</h2>
//               </Link>
//               <p className="blog-excerpt">{blog.excerpt}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* --- CHANGE 4: Conditionally render the "Show More" button --- */}
//       {visibleBlogs < blogs.length && (
//         <div className="show-more-container">
//           <button onClick={handleShowMore} className="show-more-btn">
//             Show More Blogs
//           </button>
//         </div>
//       )}
//     </section>
//     <HomeFooter />
//     </>
//   );
// };

// export default BlogList;



import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../blog.css';
import Header from "../headerFooter/header";
import HomeFooter from "../homepage/homefooter";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [visibleBlogs, setVisibleBlogs] = useState(6); // Show 6 blogs initially

  useEffect(() => {
    // Note: We fetch the posts which includes content.rendered by default
    fetch("https://satvicpath.com/wordpress/wp-json/wp/v2/posts?_embed")
      .then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      })
      .then((data) => {
        const formatted = data.map((post) => {
          // --- READ TIME CALCULATION ---
          // 1. Strip HTML tags from content
          const rawContent = post.content.rendered.replace(/<[^>]+>/g, "");
          // 2. Count words
          const wordCount = rawContent.trim().split(/\s+/).length;
          // 3. Calculate minutes (average 200 wpm)
          const minutes = Math.ceil(wordCount / 200);

          return {
            slug: post.slug,
            title: post.title.rendered,
            // Format date to: Month Day, Year (e.g., Dec 28, 2025)
            date: new Date(post.date).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            }),
            author: post._embedded.author[0].name,
            excerpt: post.excerpt.rendered.replace(/<[^>]+>/g, ""),
            image: post._embedded["wp:featuredmedia"]
              ? post._embedded["wp:featuredmedia"][0].source_url
              : "https://via.placeholder.com/400x200",
            readTime: minutes,
          };
        });
        setBlogs(formatted);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }, []);

  const handleShowMore = () => {
    setVisibleBlogs((prevVisibleBlogs) => prevVisibleBlogs + 6); // Increase by 6
  };

  return (
    <>
      <Header />
      <section className="blog-section" id="blogs">
        <h1 className="blog-heading">Blogs</h1>
        <p className="sec-subtitle">“Insights for your satvic journey"</p>

        <div className="blog-grid">
          {blogs.slice(0, visibleBlogs).map((blog) => (
            <div className="blog-card" key={blog.slug}>
              <Link to={`/post/${blog.slug}`}>
                <img src={blog.image} alt={blog.title} className="blog-image" />
              </Link>
              <div className="blog-meta">
                {/* Meta display: Date | Read Time */}
                <p className="blog-author">
                   {blog.date} | <span className="read-time-span">{blog.readTime} min read</span>
                </p>
                
                <Link to={`/post/${blog.slug}`}>
                  <h2 className="blog-title">{blog.title}</h2>
                </Link>
                <p className="blog-excerpt">{blog.excerpt}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Conditionally render the "Show More" button */}
        {visibleBlogs < blogs.length && (
          <div className="show-more-container">
            <button onClick={handleShowMore} className="show-more-btn">
              Show More Blogs
            </button>
          </div>
        )}
      </section>
      <HomeFooter />
    </>
  );
};

export default BlogList;